export const validateUrl = (channelId, uuid) => {
  return { apiUrl: `/channel-log/check-ars-expired/${channelId}?rn=${uuid}` };
};
